module.exports = __webpack_public_path__ + "img/villa_dialog_icon09.4abf9c49.png";